import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { AddNewCustomAiStoryTemplate } from '../../api/commands';
import { useStorymapStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SaveNewCustomAiStoryTemplate extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SaveNewCustomAiStoryTemplate';

    public constructor(public id: string, public name: string, public body: string, public target: number, public isVisibleByDefault: boolean = false) {
        super(SaveNewCustomAiStoryTemplate.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SaveNewCustomAiStoryTemplate): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new AddNewCustomAiStoryTemplate(action.id, state.id, action.name, action.body, action.target, action.isVisibleByDefault),
    });
};

const reducer = (state: StorymapState, action: SaveNewCustomAiStoryTemplate): void => {
    // @ts-ignore
    state.customAiStoryTemplates.push({
        id: action.id,
        name: action.name,
        body: action.body,
        target: action.target,
        isVisibleByDefault: action.isVisibleByDefault,
    });

    state.customAiStoryTemplates.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });
};

//@ts-ignore
registerMiddleware(SaveNewCustomAiStoryTemplate.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SaveNewCustomAiStoryTemplate.ACTION_TYPE, reducer);
